module.exports = __webpack_public_path__ + "static/media/expense.48f912dd.svg";